/**
 * One act name per outline column (#920).
 *
 * Hung Romance acts are named "Act 1". Do not concatenate a generic
 * "Act N" onto that name ("Act 1 · Act 1" / "ACT 1 · ACT 1").
 * Tracks still do not seed extra rows — this is header text only.
 */

const CONCAT = /^(act\s+(?:\d+|[ivxlcdm]+))\s*[·•]\s*(.+)$/i;

export function outlineActHeader(name, number) {
  const stored = String(name || '').trim();
  if (stored) {
    const match = stored.match(CONCAT);
    if (match) {
      const right = match[2].trim();
      return right || match[1].trim();
    }
    return stored;
  }
  if (number != null && String(number).trim() !== '') {
    return `Act ${number}`;
  }
  return 'Act';
}
